(function () {
  var DEFAULT_ICONS = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/></svg>',
    '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true"><circle cx="139.636" cy="384" r="11.636"/><circle cx="407.273" cy="384" r="11.636"/><path d="M498.036,262.982l-34.909-25.6l-33.745-101.236c-1.164-4.655-5.818-8.145-10.473-8.145H314.182c-6.982,0-11.636,4.655-11.636,11.636v232.727H196.655c-5.818-26.764-29.091-46.545-57.018-46.545c-27.927,0-51.2,19.782-57.018,46.545H34.909c-6.982,0-11.636-4.655-11.636-11.636v-256c0-6.982,4.655-11.636,11.636-11.636h267.636c0,6.982,4.655,11.636,11.636,11.636s11.636-4.655,11.636-11.636V81.455c0-6.982-4.655-11.636-11.636-11.636H34.909C15.127,69.818,0,84.945,0,104.727v256c0,19.782,15.127,34.909,34.909,34.909h47.709c5.818,26.764,29.091,46.545,57.018,46.545c27.927,0,51.2-19.782,57.018-46.545h117.527c6.982,0,11.636-4.655,11.636-11.636V151.273h84.945l26.764,81.455h-23.273l3.491-6.982c2.327-5.818,0-12.8-4.655-15.127c-4.655-2.327-12.8,0-15.127,4.655l-9.309,17.455h-27.927c-6.982,0-11.636,4.655-11.636,11.636S353.745,256,360.727,256h89.6l33.745,25.6c2.327,2.327,4.655,5.818,4.655,9.309v69.818c0,6.982-4.655,11.636-11.636,11.636h-12.8c-5.818-26.764-29.091-46.545-57.018-46.545c-32.582,0-58.182,25.6-58.182,58.182c0,32.582,25.6,58.182,58.182,58.182c27.927,0,51.2-19.782,57.018-46.545h12.8c19.782,0,34.909-15.127,34.909-34.909v-69.818C512,280.436,507.345,269.964,498.036,262.982z"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/><path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>'
  ];

  var MONTHS = {
    fr: ['Janv.','F\u00e9vr.','Mars','Avr.','Mai','Juin','Juill.','Ao\u00fbt','Sept.','Oct.','Nov.','D\u00e9c.'],
    en: ['Jan.','Feb.','Mar.','Apr.','May','June','July','Aug.','Sep.','Oct.','Nov.','Dec.'],
    es: ['Ene.','Feb.','Mar.','Abr.','Mayo','Jun.','Jul.','Ago.','Sep.','Oct.','Nov.','Dic.'],
    it: ['Gen.','Feb.','Mar.','Apr.','Mag.','Giu.','Lug.','Ago.','Set.','Ott.','Nov.','Dic.']
  };

  function addDays(base, days, includeSaturday, includeSunday) {
    var d = new Date(base.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      var skip = (day === 6 && !includeSaturday) || (day === 0 && !includeSunday);
      if (!skip) {
        added++;
      }
    }
    return d;
  }

  /*
   * Remplace un jeton quelle que soit la maniere dont il a ete echappe :
   * {min_date}, &lcub;min_date&rcub; ou &amp;lcub;min_date&amp;rcub;.
   * L'editeur de theme produit la deuxieme forme, une traduction faite par
   * Translate & Adapt produit la troisieme.
   */
  function remplacerJeton(texte, nom, valeur) {
    var ouvre = '(?:{|&(?:amp;)?lcub;)';
    var ferme = '(?:}|&(?:amp;)?rcub;)';
    return texte.replace(new RegExp(ouvre + nom + ferme, 'g'), valeur);
  }

  function formatDate(date, format, locale) {
    var day = date.getDate();
    var month = date.getMonth();
    if (format === 'dd_mm') {
      return (day < 10 ? '0' : '') + day + '/' + (month < 9 ? '0' : '') + (month + 1);
    }
    var lang = (locale || 'fr').substring(0, 2);
    var names = MONTHS[lang] || MONTHS.fr;
    return day + ' ' + names[month];
  }

  function init() {
    document.querySelectorAll('.hf-delivery[data-date-format]').forEach(function (widget) {
      var format = widget.getAttribute('data-date-format');
      var locale = widget.getAttribute('data-locale');
      var mode = widget.getAttribute('data-display-mode');
      var steps = widget.querySelectorAll('.hf-delivery__step');
      var now = new Date();
      var currentBase = new Date(now.getTime());

      var cutoffEnabled = widget.getAttribute('data-cutoff-enabled') === 'true';
      var pastCutoff = false;
      if (cutoffEnabled) {
        var cutoffHour = parseInt(widget.getAttribute('data-cutoff-hour'), 10);
        var cutoffMinute = parseInt(widget.getAttribute('data-cutoff-minute'), 10) || 0;
        if (!isNaN(cutoffHour)) {
          var nowMinutes = now.getHours() * 60 + now.getMinutes();
          var cutoffMinutes = cutoffHour * 60 + cutoffMinute;
          pastCutoff = nowMinutes >= cutoffMinutes;
        }
      }

      var lastMin, lastMax;

      steps.forEach(function (step, i) {
        var iconDiv = step.querySelector('.hf-delivery__icon');
        if (iconDiv && !iconDiv.children.length && DEFAULT_ICONS[i]) {
          iconDiv.innerHTML = DEFAULT_ICONS[i];
        }

        var minDays = parseInt(step.getAttribute('data-min-days'), 10) || 0;
        var maxDays = parseInt(step.getAttribute('data-max-days'), 10) || 0;
        var enableRange = step.getAttribute('data-enable-range') === 'true';
        var includeSaturday = step.getAttribute('data-include-saturday') === 'true';
        var includeSunday = step.getAttribute('data-include-sunday') === 'true';
        var applyCutoff = step.getAttribute('data-apply-cutoff') === 'true';

        if (applyCutoff && pastCutoff) {
          currentBase = addDays(currentBase, 1, includeSaturday, includeSunday);
        }
        if (applyCutoff) {
          while ((currentBase.getDay() === 6 && !includeSaturday) || (currentBase.getDay() === 0 && !includeSunday)) {
            currentBase.setDate(currentBase.getDate() + 1);
          }
        }

        lastMin = addDays(currentBase, minDays, includeSaturday, includeSunday);
        lastMax = enableRange ? addDays(currentBase, maxDays, includeSaturday, includeSunday) : lastMin;
        currentBase = enableRange ? new Date(lastMax.getTime()) : new Date(lastMin.getTime());

        var dateEl = step.querySelector('.hf-delivery__date');
        if (dateEl) {
          var text = formatDate(lastMin, format, locale);
          if (enableRange) text += ' - ' + formatDate(lastMax, format, locale);
          dateEl.textContent = text;
        }
      });

      if (mode === 'simple' && steps.length > 0) {
        var phraseEl = widget.querySelector('.hf-delivery__text');
        var tplEl = widget.querySelector('.hf-delivery__text-template');
        var template = tplEl ? tplEl.innerHTML : '';
        if (phraseEl && template) {
          var minStr = formatDate(lastMin, format, locale);
          var maxStr = formatDate(lastMax, format, locale);
          var phrase = remplacerJeton(template, 'min_date', minStr);
          phrase = remplacerJeton(phrase, 'max_date', maxStr);
          phraseEl.innerHTML = phrase;
        }
        var phraseContainer = widget.querySelector('.hf-delivery__phrase');
        var iconEl = phraseContainer ? phraseContainer.querySelector('.hf-delivery__phrase-icon') : null;
        if (phraseContainer && iconEl && phraseContainer.dataset.iconPosition === 'after') {
          phraseContainer.appendChild(iconEl);
        }
      }

      if (mode === 'steps') {
        var firstChild = steps[0];
        var lastChild = steps[steps.length - 1];
        if (firstChild) firstChild.classList.add('hf-delivery__step--first');
        if (lastChild) lastChild.classList.add('hf-delivery__step--last');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:block:deselect', init);
  }
})();
